export default __webpack_public_path__ + "img/WB_RTK.1078d2a5c6262aa6805f507914fdbd52.jpg";